export function headerSticky() {
    const $header = $(".header");
    const $window = $(window);

    $window.on("load scroll", function () {
        if ($window.scrollTop() > 0) {
            $header.addClass("sticky");
        } else {
            $header.removeClass("sticky");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerSticky.js